import { Link } from "react-router-dom";
import styles from "./Navbar.module.css";
import { useContext, useState } from "react";
import { Context } from "../../context/UserContext";
const { v4: uuidv4 } = require("uuid");

function Navbar() {
    const { authenticated, logout, permissaoUsuario } = useContext(Context);
    const [openMenu, setOpenMenu] = useState(null); // Estado para controlar o submenu aberto

    let groups = {};
    if (permissaoUsuario.length !== undefined) {
        groups = permissaoUsuario?.reduce((groups, item) => {
            const group = groups[item.Menu.descricao] || [];
            group.push(item);
            groups[item.Menu.descricao] = group;
            return groups;
        }, {});
    }

    // Função para alternar a exibição do submenu
    const toggleSubMenu = (key) => {
        setOpenMenu(openMenu === key ? null : key);
    };

    // Função para fechar todos os submenus ao clicar em um item
    const closeSubMenus = () => {
        setOpenMenu(null);
    };

    return (
        <nav className={styles.navbar} id="menu">
            <ul>
                {authenticated ? (
                    <>
                        {permissaoUsuario.length !== undefined &&
                            Object.keys(groups).map((key) => (
                                <li key={uuidv4()}>
                                    <button type="button" className={styles.menuButton} onClick={() => toggleSubMenu(key)}>
                                        {key}
                                    </button>
                                    <ul className={openMenu === key ? styles.active : ""}>
                                        {groups[key]?.map((pm) => (
                                            <li key={pm.menuSub.uuid} onClick={closeSubMenus}>
                                                <Link
                                                    to={{
                                                        pathname: pm.menuSub.url,
                                                        search: `?ul=${pm.menuId}&li=${pm.menuSubId}&tipo=${
                                                            pm.menuSub.tipo || ""
                                                        }&operacao=${pm.menuSub?.Operacao?.uuid || ""}&natureza=${
                                                            pm.menuSub?.natureza || ""
                                                        }&`,
                                                    }}
                                                    title={pm.menuSub.title}
                                                >
                                                    {pm.menuSub.descricao}
                                                </Link>
                                            </li>
                                        ))}
                                    </ul>
                                </li>
                            ))}
                        <li>
                            <button
                                type="button"
                                className={styles.menuButton}
                                onClick={logout}
                                title="Clique para sair do sistema"
                            >
                                Sair
                            </button>
                        </li>
                    </>
                ) : (
                    <>
                        <li>
                            <Link to="/Auth" className={styles.menuButton} title="Clique para acessar o sistema">
                                Acessar
                            </Link>
                        </li>
                    </>
                )}
            </ul>
        </nav>
    );
}

export default Navbar;
